// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".identity[data-v-f5b6b090]{width:90%;margin:auto}@media only screen and (max-width: 959px){.identity[data-v-f5b6b090]{width:100%}}@media only screen and (max-width: 959px){.text-align-right[data-v-f5b6b090]{text-align:left}}", ""]);
// Exports
module.exports = exports;
